import { Link } from 'react-router-dom';
import ListErrors from './ListErrors';
import React from 'react';
import agent from '../agent';
import { connect } from 'react-redux';
import Loading from './widgets/Loading'
import RateList from './widgets/RateList';
import {
    RATES_PAGE_LOADED,
    RATES_PAGE_UNLOADED,
} from '../constants/actionTypes';

const mapStateToProps = state => ({
    ...state.settings,
});

const mapDispatchToProps = dispatch => ({
    onLoad: (payload) => {
        dispatch({ type: RATES_PAGE_LOADED, payload })
    },
    onUnload: () =>
        dispatch({ type: RATES_PAGE_UNLOADED })
});

class Rates extends React.Component {
    constructor() {
        super();
    }
    componentWillMount() {
        const payload = agent.Rates.getAllRates()
        this.props.onLoad(payload);
    }

    componentWillUnmount() {
        this.props.onUnload();
    }
    render() {
        return (
            <div class='pane'>
                <Link className="buttonTop" to='/rate/create'><i className="icon ion-android-add-circle"></i></Link>
                <h1>Rates</h1>
                <RateList rates={this.props.rates} loading={this.props.loading} />
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Rates);



// WEBPACK FOOTER //
// ./src/components/Rates.js